import React, { useState, useEffect } from 'react'
import { PaginationControl } from "react-bootstrap-pagination-control";
import IconButton from '@mui/material/IconButton'
import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'
import { Link } from 'react-router-dom'
import { Get, Delete } from '../../web_api/api'
import '../../branch/branch.css'

export default function Main() {

    const [dataCount, setDataCount] = useState("");
    const [page, setPage] = useState(1)
    const [blogList, setBlogList] = useState([])
    const [rowsPerPage, setRowsPerPage] = React.useState(10);

    const paginationItems = React.useMemo(() => {
        const start = (page - 1) * rowsPerPage;
        const end = start + rowsPerPage;
        return blogList.slice(start, end);
    }, [page, blogList]);

    const handleDelete = async (event) => {
        await Delete('/blog/', event)
        const result = blogList.filter(item => item._id !== event)
        setBlogList(result)
    }

    useEffect(() => {
        const getBlogs = async () => {
            const res = await Get('blogs')
            setBlogList(res.data)
            setDataCount(res.data.length)
        }
        getBlogs()
    }, [])

    return (
        <div className='branch-page'>
            <div className='branch-breadcrumb'>
                <span className='current'>Treatment List</span>
            </div>

            <div className='branch-card'>
                <div className='branch-card-header'>
                    <span />
                    <Link to='/treatment-create' className='branch-btn branch-btn-primary'>
                        + Add
                    </Link>
                </div>

                <div className='branch-card-body' style={{ padding: 0 }}>
                    <div className='branch-table-wrapper'>
                        <table className='branch-table'>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Treatment Name</th>
                                    <th>Type</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {paginationItems.map((blog, i) => (
                                    <tr key={i}>
                                        <td>{++i}</td>
                                        <td>{blog.name}</td>
                                        <td>{blog.type ? (blog.type === 'face' ? 'Face & Skin' : (blog.type === 'body' ? 'Body Contouring' : 'Dental Care')) : ''}</td>
                                        <td>
                                            <IconButton
                                                aria-label='delete'
                                                onClick={() => handleDelete(blog._id)}
                                            >
                                                <DeleteIcon className='text-danger' />
                                            </IconButton>
                                            <Link to={'/treatment-update/' + blog._id}>
                                                <IconButton aria-label='edit'>
                                                    <EditIcon className='text-warning' />
                                                </IconButton>
                                            </Link>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'center', padding: '16px 0' }}>
                        <PaginationControl
                            page={page}
                            between={4}
                            total={dataCount}
                            limit={10}
                            changePage={(page) => {
                                setPage(page);
                            }}
                            ellipsis={1}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}
